<template>
  <div class="movieModal">
    <img
      src="/static/img/metal/complete.jpg"
      alt
      class="movieModal__image"
      v-on:click="switchModalFlag(true)"
      v-if="isShowImage"
    >
    <p class="movieModal__button" v-on:click="switchModalFlag(true)" v-if="isShowButton">もう一度カードを引く</p>
    <div class="movieModal__modal" v-bind:class="[{ '-on': isOpened }]">
      <div class="movieModal__modal__filter" v-on:click="switchModalFlag(false)"></div>
      <div class="movieModal__modal__content">
        <video controls></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'movie-modal',
  data() {
    return {
      isOpened: false,
      video: null
    };
  },
  props: {
    movieUrl: { type: String, default: '' },
    jumpUrl: { type: String, default: '' },
    isShowImage: { type: Boolean, default: false },
    isShowButton: { type: Boolean, default: false }
  },
  mounted() {
    this.video = this.$el.querySelector('video');
    this.video.addEventListener('ended', () => {
      if (this.jumpUrl) location.href = this.jumpUrl;
    });
    this.video.addEventListener('play', event => {
      gtag('event', 'Play', { event_category: 'Videos', event_label: `動画再生_shuffle_heavymetal` });
    });
  },
  methods: {
    switchModalFlag(flag) {
      this.video.src = this.movieUrl;
      flag ? this.video.play() : this.video.pause();
      if (platform.product !== 'iPhone') this.isOpened = flag;
    }
  }
};
</script>

<style lang="scss">
.movieModal {
  &__image {
    display: block;
    width: 100%;
    cursor: pointer;
  }
  &__button {
    margin: 32px 40px 0;
    padding: 19px 0;
    line-height: 1.33;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: white;
    background: linear-gradient(180deg, #7c7c7c 0%, black 100%);
    box-shadow: 0px 6px 8px rgba(black, 0.8);
    border: 2px solid #888888;
    border-radius: 6px;
    cursor: pointer;
  }
  &__modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0;
    z-index: 100;
    pointer-events: none;
    &.-on {
      opacity: 1;
      pointer-events: auto;
    }
    &__filter {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(black, 0.5);
      &::before,
      &::after {
        content: '';
        position: absolute;
        top: 23px;
        right: 12px;
        width: 28px;
        height: 4px;
        border-radius: 2px;
        background: white;
        transform: rotate(45deg);
        transform-origin: center;
      }
      &::after {
        transform: rotate(-45deg);
      }
    }
    &__content {
      position: relative;
      height: calc(100% - 96px);
      max-height: 640px;
      video {
        display: block;
        height: 100%;
        margin: 0 auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/MovieModal.vue